import React, { useEffect, useState } from 'react'
import { useTranslate } from 'src/localization/Trns'

import styles from './InvoicePreviewShelf.style'

export interface InvoicePreviewShelfProps {
  file: File
}

/** Browser-only preview of the exact File selected in the current draft. */
const InvoicePreviewShelf: React.FC<InvoicePreviewShelfProps> = ({ file }) => {
  const translate = useTranslate()
  const [objectUrl, setObjectUrl] = useState<string | null>(null)

  useEffect(() => {
    const url = URL.createObjectURL(file)
    setObjectUrl(url)
    return () => URL.revokeObjectURL(url)
  }, [file])

  const isPdf = file.type === 'application/pdf'

  return (
    <div
      css={styles}
      className={isPdf ? 'preview-root--document' : 'preview-root--image'}
      data-testid={'invoice-preview-shelf'}
    >
      {objectUrl !== null &&
        (isPdf ? (
          <object
            className={'preview-document'}
            data={objectUrl}
            type={'application/pdf'}
            aria-label={translate('PDF preview of ${filename}', {
              filename: file.name,
            })}
            title={translate('PDF preview of ${filename}', {
              filename: file.name,
            })}
          />
        ) : (
          <img
            className={'preview-image'}
            src={objectUrl}
            alt={translate('Preview of invoice ${filename}', {
              filename: file.name,
            })}
          />
        ))}
    </div>
  )
}

export default InvoicePreviewShelf
